// Module
var code = `<!-- ko with: model -->
<tr data-bind="click: toggle, key2click">
    <td class="svd-dark-border-color" data-bind="style: { paddingLeft: textMargin }">
        <!-- ko if: isNode -->
        <span class="svd-test-results__marker" data-bind="css: { 'svd-test-results__marker--expanded': !collapsed },
                         style: { left: markerMargin }">
            <sv-svg-icon params="iconName: 'icon-expand_16x16', size: 16"></sv-svg-icon>
        </span>
        <!-- /ko -->
        <!-- ko if: \$data.question -->
        <!-- ko template: { name: 'survey-string', data: question.locTitle } --><!-- /ko -->
        <!-- /ko -->
        <!-- ko ifnot: \$data.question -->
        <span data-bind="text: title"></span>
        <!-- /ko -->
    </td>
    <td data-bind="css: (isNode ? 'svd-test-results__node-value' : 'svd-dark-border-color'), text: getString(displayValue)">
    </td>
</tr>
<!-- ko if: isNode && !collapsed -->
<!-- ko foreach: data -->
<!-- ko component: { name: 'survey-results-table-row', params: { model: \$data } } -->
<!-- /ko -->
<!-- /ko -->
<!-- /ko -->
<!-- /ko -->`;
// Exports
export default code;